'use strict';

import angular from 'angular';
import DocumentService from './Document';
import InsurancePersonService from './InsurancePerson';
import InsuranceOfferService from './InsuranceOffer';
import OrderOczfpService from './OrderOczfp';
import PersonService from './Person';
import OrderNnwService from './OrderNnw';
import SubscribeService from './Subscribe';
import LotosCardsService from './Lotos-cards';

export default angular.module('ngOskCrmApp.model', [])
  .service('Document', DocumentService)
  .service('InsurancePerson', InsurancePersonService)
  .service('insuranceOffer', InsuranceOfferService)
  .service('Person', PersonService)
  .service('OrderOczfp', OrderOczfpService)
  .service('OrderNnw', OrderNnwService)
  .service('Subscribe', SubscribeService)
  .service('LotosCards', LotosCardsService)
  .name;



// WEBPACK FOOTER //
// ./client/app/shared/model/index.js